export interface FacultyMember {
  id: string;
  name: string;
  empId: string;
  email: string;
  totalEntries: number;
  department: string;
  designation?: string;
}

export interface DepartmentStats {
  articlePublications: number;
  textBookPublications: number;
  patents: number;
  copyRights: number;
  fellowship: number;
  phd: number;
  swayamCourses: number;
  awards: number;
  innovativeTeaching: number;
  eContent: number;
  researchGrants: number;
  guestLectures: number;
  conferencePresentations: number;
  shortResearchProjects: number;
}

export interface Department {
  id: string;
  name: string;
  facultyCount: number;
  totalEntries: number;
  stats: DepartmentStats;
  members: FacultyMember[];
  accentColor: 'purple' | 'teal' | 'coral' | 'blue' | 'amber' | 'pink' | 'green' | 'gray' | 'red';
}

export type ActivityLevel = 'High' | 'Active' | 'Growing' | 'Low';

export const DEPARTMENT_COLORS = {
  purple: {
    50: '#faf5ff',
    100: '#f3e8ff',
    200: '#e9d5ff',
    600: '#9333ea',
    800: '#6b21a8',
    900: '#581c87',
  },
  teal: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    600: '#14b8a6',
    800: '#115e59',
    900: '#134e4a',
  },
  coral: {
    50: '#fff7ed',
    100: '#ffedd5',
    200: '#fed7aa',
    600: '#ea580c',
    800: '#9a3412',
    900: '#7c2d12',
  },
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    600: '#2563eb',
    800: '#1e40af',
    900: '#1e3a8a',
  },
  amber: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    600: '#d97706',
    800: '#92400e',
    900: '#78350f',
  },
  pink: {
    50: '#fdf2f8',
    100: '#fce7f3',
    200: '#fbcfe8',
    600: '#db2777',
    800: '#9d174d',
    900: '#831843',
  },
  green: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    600: '#16a34a',
    800: '#166534',
    900: '#14532d',
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    600: '#4b5563',
    800: '#1f2937',
    900: '#111827',
  },
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    600: '#dc2626',
    800: '#991b1b',
    900: '#7f1d1d',
  },
};

export const COLOR_NAMES = Object.keys(DEPARTMENT_COLORS);
